'use strict';

export class init {
    constructor(opt) {
        this.opt = opt;
        this.bindHandlers();
        this.starSvg = '<svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
            '<path d="M29.9207 10.7685C29.7272 10.2015 29.2157 9.801 28.6187 9.7545L20.0672 9.075L16.3667 0.8835C16.1252 0.345 15.5897 0 15.0002 0C14.4107 0 13.8752 0.345 13.6337 0.882L9.93321 9.075L1.38171 9.7545C0.795213 9.801 0.289712 10.1865 0.0902124 10.74C-0.109288 11.2935 0.0317125 11.913 0.453213 12.324L6.77271 18.4845L4.53771 28.1625C4.39971 28.761 4.64121 29.3835 5.14671 29.733C5.40471 29.91 5.70171 30 6.00021 30C6.28971 30 6.58071 29.916 6.83271 29.748L15.0002 24.303L23.1677 29.748C23.6897 30.096 24.3752 30.0825 24.8852 29.712C25.3922 29.3415 25.6157 28.692 25.4432 28.089L22.6997 18.489L29.5037 12.366C29.9492 11.964 30.1127 11.337 29.9207 10.7685Z" fill="#EEB200"/>\n' +
            '</svg>\n';
    }

    bindHandlers() {
        let _this = this;
        _this.rateInit();
        _this.initAll();
    }

    initAll() {
        let _this = this;

        let rateEl = $('.rate-site');
        _this.rateDefaultInit(rateEl)

        rateEl.rateYo().on('rateyo.set', function (e, data) {
                let form = $(this).parent().find('form');
                form.find('input.rate-hidden-input').remove();

                $('<input>').attr({
                    type: 'hidden',
                    name: 'rate',
                    value: data.rating,
                    class: 'rate-hidden-input'
                }).appendTo(form);

                $(this).parents('.leave-review').find('.review-add').removeClass('disabled');
            }
        );

        // Reviews admin actions popup
        $(document).find('.admin-actions .popup-image').off('click').on('click', function () {
            $(this).parent().find('.admin-actions-popup').toggleClass('active');
        });

        $(document).mouseup(function (e) {
            let reviewsPopupActions = $('.admin-actions');
            if (!reviewsPopupActions.is(e.target)
                && reviewsPopupActions.has(e.target).length === 0) {
                $('.admin-actions .admin-actions-popup').removeClass('active');
            }
        });

        $('.review-add').off('click').on('click', function () {
            let el = $(this);
            el.prop('disabled', true);

            let form = el.parents('form');
            $.post(form.attr('action'), form.serialize()).done(function (data) {
                if (data.success) {
                    el.prop('disabled', false);

                    $(data.review).insertAfter('div.review-amount-wrap');
                    _this.clearForm(form);
                    _this.scrollToNewReview(data.reviewId);
                    _this.increaseReviewAmount(data.amount);
                    _this.rateInit();
                    _this.initAll();
                } else {
                    console.info(data.message);
                }
            });
        });

        $(document).find('.review-edit').off('click').on('click', function () {
            let el = $(this);
            el.prop('disabled', true);

            let form = el.closest('.review-or-comment-wrapper form');
            let id = form.find('input.id-hidden-input').val();
            let wrapper = el.parents('#' + id);

            $.post(form.attr('action'), form.serialize()).done(function (data) {
                if (false === data.success) {
                    console.info(data.message);
                } else if (data.review) {
                    wrapper.replaceWith(data.review);

                    el.prop('disabled', false);
                    _this.clearEditForm(form);
                    _this.rateInit();
                    _this.initAll();
                }
            });
        });

        $(document).find('.review-answer').off('click').on('click', function () {
            let el = $(this);
            el.prop('disabled', true);

            let form = el.parents('form');
            $.post(form.attr('action'), form.serialize()).done(function (data) {
                if (data.success) {
                    el.prop('disabled', false);

                    $(document).find('.previous-review-item#' + data.reviewId).replaceWith(data.review);
                    _this.rateInit();
                    _this.initAll();
                    _this.increaseReviewAmount(data.amount);
                } else {
                    console.info(data.message);
                }
            });
        });

        $(document).find('.close-review-popup').off('click').on('click', function (e) {
            e.preventDefault();
            $(this).parents('.review-popup-wrapper').css('display', 'none');
        });

        $(document).find('.review-delete').off('click').on('click', function (e) {
            e.preventDefault();
            let el = $(this);

            let popup = el.closest('.review-or-comment-wrapper').find('.delete-admin-popup').first();
            if (el.hasClass('review-delete-by-admin')) {
                let btn = popup.find('a.review-delete');
                btn.attr('data-action', btn.attr('data-path') + '/' + $('input:checked').attr('data-reason'));
                popup.css('display', 'flex');
                return false;
            } else {
                popup.css('display', 'none');
            }

            let isSelfDelete = el.hasClass('review-delete-by-user');
            el.prop('disabled', true);

            $.post(el.attr('data-action'), {'review-delete-by-user': isSelfDelete})
                .done(function (data) {
                    if (data.success) {
                        el.prop('disabled', false);

                        let review = $(document).find('.previous-review-item#' + data.reviewId);
                        if (isSelfDelete) {
                            review.remove();
                        } else {
                            review.replaceWith(data.review);
                            _this.rateInit();
                            _this.initAll();
                        }

                        _this.increaseReviewAmount(data.amount);
                        toastr.success(data.message);
                    } else {
                        console.info(data.message);
                    }
                });
        });

        $(document).find('.change-reason-admin-delete').on('change', function () {
            let el = $(this);
            let btn = el.parents('.popup').find('.review-delete');
            btn.attr('data-action', btn.attr('data-path') + '/' + el.attr('data-reason'));
        });

        $(document).find('.review-ban').off('click').on('click', function () {
            let el = $(this);

            let popup = false;
            if (el.hasClass('review-ban-30-days-by-admin')) {
                popup = el.closest('.review-or-comment-wrapper').find('.ban-30-days-admin-popup').first();
            } else if (el.hasClass('review-ban-by-admin')) {
                popup = el.closest('.review-or-comment-wrapper').find('.ban-admin-popup').first();
            }

            if (popup) {
                let btn = popup.find('a.review-ban')
                btn.attr('data-action', btn.attr('data-path') + '/' + $('input:checked').attr('data-reason'));
                popup.css('display', 'flex');
                return false;
            }

            $(document).find('.review-popup-wrapper').css('display', 'none');
            $.post(el.attr('data-action')).done(function (data) {
                if (data.success) {
                    toastr.success(data.message);
                } else {
                    console.info(data.message);
                }
            });
        });

        $(document).find('.change-reason-admin-ban').on('change', function () {
            let el = $(this);
            let btn = el.parents('.popup').find('.review-ban');
            btn.attr('data-action', btn.attr('data-path') + '/' + el.attr('data-reason'));
        });

        $('.reviews-wrap textarea').each(function () {
            let form = $(this).parent();
            let addCommentBtn = form.find('.review-add');
            let hiddenRateInput = form.find('input.rate-hidden-input');
            if ('' === $.trim($(this).val()) && hiddenRateInput.length === 0) {
                addCommentBtn.addClass('disabled');
            } else {
                addCommentBtn.removeClass('disabled');
            }

            $(this).bind('change keyup paste', function () {
                hiddenRateInput = form.find('input.rate-hidden-input');
                if ('' === $.trim($(this).val()) && hiddenRateInput.length === 0) {
                    addCommentBtn.addClass('disabled');
                } else {
                    addCommentBtn.removeClass('disabled');
                }
            });
        });

        $(document).find('.reviews-wrap .answer').off('click').on('click', function () {
            let el = $(this);

            let wrapper = el.closest('.review-or-comment-wrapper');
            wrapper.find('.review-answer').first().addClass('active');
            wrapper.find('.review-answer-btn').first().addClass('active');
            let form = wrapper.find('form');
            form.find('input.answer-to-user-hidden-input').remove();

            $('<input>').attr({
                type: 'hidden',
                name: 'answer-to-user',
                value: el.attr('data-answer-to-user-id'),
                class: 'answer-to-user-hidden-input'
            }).appendTo(form);
        });

        $(document).find('.reviews-wrapper .cancel').off('click').on('click', function () {
            $(this).parents('.previous-review-item').find('.review-answer').removeClass('active');
        });

        $(document).find('.reviews-wrapper .edit').off('click').on('click', function () {
            let el = $(this);
            let wrap = el.closest('.review-or-comment-wrapper');
            let text = wrap.find('.review-text').first().text();

            wrap.find('.edit-answer textarea').first().val($.trim(text));
            wrap.find('.edit-answer').first().addClass('active');

            _this.rateDefaultInit(wrap.find('.rate-site'));
        });

        $(document).off('click').on('click', '.reviews-wrapper .cancel', function () {
            $(this).parents('.previous-review-item').find('.edit-answer').removeClass('active');
        });

        $('.attachment-files').magnificPopup({
            type: 'image'
        });

        $('.previous-review-item').each(function () {
            $(this).find('.previous-review-comment:first').css('display', 'flex');
        });

        $(document).find('.show-all-comments').off('click').on('click', function () {
            $(this).addClass('hidden');

            let wrapper = $(this).closest('.review-or-comment-wrapper');
            wrapper.find('.previous-review-comment').css('display', 'flex');
            wrapper.find('.hide-all-comments').removeClass('hidden');
        });

        $(document).find('.hide-all-comments').off('click').on('click', function () {
            $(this).addClass('hidden');

            let wrapper = $(this).closest('.review-or-comment-wrapper');
            let prevComment = wrapper.find('.previous-review-comment');
            prevComment.css('display', 'none');
            prevComment.first().css('display', 'flex');
            wrapper.find('.show-all-comments').removeClass('hidden');
        });

        let prevReviewItem = $(document).find('.previous-review-item .what-comment-review');
        prevReviewItem.mouseover(function () {
            $(this).closest('.review-or-comment-wrapper').find('.review-text').addClass('hover');
        });

        prevReviewItem.mouseout(function () {
            $(this).closest('.review-or-comment-wrapper').find('.review-text').removeClass('hover');
        });
    }

    clearForm(form) {
        form.find('textarea').val('');
        form.parents('.leave-review').find('.rate-site').rateYo('option', 'rating', '0');
        form.find('input.rate-hidden-input').remove();
    }

    clearEditForm(form) {
        form.find('textarea').val('');
        form.parents('.edit-answer').find('.rate-site').rateYo('option', 'rating', '0');
        form.find('input.rate-hidden-input').remove();
    }

    rateInit() {
        let _this = this;
        $(document).find('.previous-rate-site').each(function () {

            let rateEl = $(this);
            let rate = rateEl.attr('data-rate');

            if (rate === '') {
                rate = 0;
            }

            $(document).ready(function () {
                rateEl.rateYo({
                    starWidth: '15px',
                    rating: rate,
                    spacing: '5px',
                    fullStar: true,
                    readOnly: true,
                    ratedFill: '#EEB200',
                    starSvg: _this.starSvg
                });
            });
        });
    }

    rateDefaultInit(el) {
        let _this = this;

        let rate = el.attr('data-rate');
        if ('' === el.attr('data-rate')) {
            rate = 0;
        }

        el.rateYo({
            rating: rate,
            spacing: '15px',
            fullStar: true,
            ratedFill: '#EEB200',
            starSvg: _this.starSvg
        });

        el.rateYo('option', 'rating', rate);
    }

    increaseReviewAmount(amount) {
        $('span#review-amount').html(amount);
    }

    scrollToNewReview(id) {
        let container = $('html,body');
        let scrollTo = $('#' + id);
        container.animate({
            scrollTop: scrollTo.offset().top - 120,
            scrollLeft: 0
        }, 1000);
    }
}